import {
  RiEyeFill,
  RiPsychotherapyFill,
  RiStethoscopeFill,
  RiCapsuleFill,
  RiMicroscopeFill,
  RiPulseFill,
  RiEmpathizeFill,
  RiMindMap,
  RiMentalHealthLine,
  RiAppleLine,
  RiInfraredThermometerLine,
} from "../../assets/icons/vander";

import client1 from "../../assets/images/client/01.jpg";
import client2 from "../../assets/images/client/02.jpg";
import client3 from "../../assets/images/client/03.jpg";
import client4 from "../../assets/images/client/04.jpg";
import client5 from "../../assets/images/client/05.jpg";
import client6 from "../../assets/images/client/06.jpg";
import client7 from "../../assets/images/client/07.jpg";
import client8 from "../../assets/images/client/08.jpg";
import client9 from "../../assets/images/client/09.jpg";
import client10 from "../../assets/images/client/10.jpg";

import dr1 from "../../assets/images/doctors/01.jpg";
import dr2 from "../../assets/images/doctors/02.jpg";
import dr3 from "../../assets/images/doctors/03.jpg";
import dr4 from "../../assets/images/doctors/04.jpg";
import dr5 from "../../assets/images/doctors/05.jpg";
import dr6 from "../../assets/images/doctors/06.jpg";
import dr7 from "../../assets/images/doctors/07.jpg";
import dr8 from "../../assets/images/doctors/08.jpg";
import dr9 from "../../assets/images/doctors/09.jpg";
import dr10 from "../../assets/images/doctors/10.jpg";

import blog1 from "../../assets/images/blog/01.jpg";
import blog2 from "../../assets/images/blog/02.jpg";
import blog3 from "../../assets/images/blog/03.jpg";
import blog4 from "../../assets/images/blog/04.jpg";
import blog5 from "../../assets/images/blog/05.jpg";
import blog6 from "../../assets/images/blog/06.jpg";
import blog7 from "../../assets/images/blog/07.jpg";
import blog8 from "../../assets/images/blog/08.jpg";
import blog9 from "../../assets/images/blog/09.jpg";

export const medicalServices = [
  {
    icon: RiEyeFill,
    title: "Registro Doctores",
    desc: "Alimenta la base de datos del equipo médico disponible.",
  },
  {
    icon: RiPsychotherapyFill,
    title: "Registro Pacientes",
    desc: "Registra pacientes en la base de datos.",
  },
  {
    icon: RiStethoscopeFill,
    title: "Disponibilidad de Salas de procedimientos",
    desc: "Registra la agenda programada en cada sala. Nosotros nos encargámos de optimizar el agendamiento.",
  },
  {
    icon: RiCapsuleFill,
    title: "Disponibilidad de agendas médicas",
    desc: "Registra la agenda programada por cada profesional de anestesia. Nosotros nos encargamos de optimizar el agendamiento.",
  },
  {
    icon: RiMicroscopeFill,
    title: "Agendamiento citas pacientes anestesiologia",
    desc: "Valora a tus pacientes y optimiza el tiempo escribiendo en la historia clínica con plantillas generadas por IA.",
  },
  {
    icon: RiPulseFill,
    title: "Agendamiento procedimientos de anestésia o quirurgicos",
    desc: "Gracias a nuestra estratificación de riesgo, los pacientes de bajo riesgo podrán agendar su procedimiento y firmar sus consentimientos informados de manera digital.",
  },
  {
    icon: RiEmpathizeFill,
    title: "Seguimiento pacientes",
    desc: "Go Safe permite que califiques el servicio pre anestésico, así como documentar todas las decisiones tomadas para la prestación de un servicio de anestesia o quirúrgico",
  },
  {
    icon: RiMindMap,
    title: "Reagendamiento inteligente",
    desc: "Usamos IA para aprovechar los espacios cancelados y aumentar el número de pacientes intervenidos por unidad de tiempo en IPSs con congestión.",
  },
  {
    icon: RiMentalHealthLine,
    title: "Dermatologists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiAppleLine,
    title: "Nutritionists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
  {
    icon: RiInfraredThermometerLine,
    title: "Physical Therapists",
    desc: "There is now an abundance of readable dummy texts required purely to fill a space.",
  },
];

export const counterData = [
  {
    target: "20",
    symbol: "+",
    titleOne: "Años de experiencia médica",
    titleTwo: "",
  },
  {
    target: "3",
    symbol: "+",
    titleOne: "IPS asociadas",
    titleTwo: "",
  },
  {
    target: "180",
    symbol: "+",
    titleOne: "Procedimientos agendados",
    titleTwo: "",
  },
];

export const patientsData = [
  {
    image: client1,
    name: "- Thomas Israel",
    title: "C.E.O",
    desc: '" Gracias a mi experiencia con Go Safe, pude solucionar mi problema de salud en un tiempo razonable. "',
    desc2:
      '" Gracias a mi experiencia con Go Safe, pude solucionar mi problema de salud en un tiempo razonable. "',
  },
  {
    image: client2,
    name: "- Carl Oliver",
    title: "P.A",
    desc: '" Go safe me ayudo con mi proceso de cirugía, no tuve que perder tiempo con autorizaciones y citas de anestesiólogo. "',
    desc2:
      '" Go safe me ayudo con mi proceso de cirugía, no tuve que perder tiempo con autorizaciones y citas de anestesiólogo. "',
  },
  {
    image: client3,
    name: "- Barbara McIntosh",
    title: "M.D",
    desc: '" Desde la comodidad de mi casa agilice mi cita de anestesiología y me pude operar más rápido. "',
    desc2:
      '" Desde la comodidad de mi casa agilice mi cita de anestesiología y me pude operar más rápido. "',
  },
  {
    image: client4,
    name: "- Christa Smith",
    title: "Manager",
    desc: '" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero in 45 BC. Allegedly, a Latin scholar established the origin of the text by compiling all the instances of the unusual word consectetur he could find "',
    desc2:
      '" According to most sources in order to have a ready-made text to sing with the melody the origin of the text by compiling all the instances. "',
  },
  {
    image: client5,
    name: "- Dean Tolle",
    title: "Developer",
    desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century. "',
    desc2:
      '" It seems that only in order to have a ready-made text to sing with the melody Lorem Ipsum, which is said to have originated 16th century. "',
  },
  {
    image: client6,
    name: "- Jill Webb",
    title: "Designer",
    desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "',
    desc2:
      '" It seems that only lyrics when writing melodies in order to have a ready-made text to sing with the melody of time certain letters were added or deleted at the text. "',
  },
  {
    image: client7,
    name: "- Howard Tanner",
    title: "C.E.O",
    desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century. "',
    desc2:
      '" It seems that only in order to have a ready-made text to sing with the melody Lorem Ipsum, which is said to have originated 16th century. "',
  },
  {
    image: client8,
    name: "- Wendy Filson",
    title: "Designer",
    desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "',
    desc2:
      '" It seems that only lyrics when writing melodies in order to have a ready-made text to sing with the melody of time certain letters were added or deleted at the text. "',
  },
];

export const doctorData = [
  {
    image: dr1,
    name: "Calvin Carlo",
    speciality: "Eye Care",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr2,
    name: "Cristino Murphy",
    speciality: "M.B.B.S, Gynecologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr3,
    name: "Alia Reddy",
    speciality: "M.B.B.S, Psychotherapist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr4,
    name: "Toni Kovar",
    speciality: "M.B.B.S, Orthopedic",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr5,
    name: "Jessica McFarlane",
    speciality: "M.B.B.S, Dentist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr6,
    name: "Elsie Sherman",
    speciality: "Elsie Sherman",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr7,
    name: "Bertha Magers",
    speciality: "M.B.B.S, Urologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
  {
    image: dr8,
    name: "Louis Batey",
    speciality: "M.B.B.S, Neurologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    charges: "$ 75 USD / Visit",
  },
];

export const blogData = [
  {
    id: 1,
    image: blog1,
    title: "Envío del cuestionario para estratificación del riesgo.",
    like: "33",
    comment: "08",
    date: "13th Sep 2023",
    time: "5 min read",
  },
  {
    id: 2,
    image: blog2,
    title: "Emisión de instructivo personalizado en el cuidado preanestésico. Tus pacientes Verán recomendaciones para su procedimiento y notificaciones personalizadas así como la firma de consentimientos informados.",
    like: "33",
    comment: "08",
    date: "29th Nov 2023",
    time: "5 min read",
  },
  {
    id: 3,
    image: blog3,
    title: "Agendamiento y reagendamiento inteligente de procedimientos de bajo y medio riesgo mediante Go Safe",
    like: "33",
    comment: "08",
    date: "29th Dec 2023",
    time: "5 min read",
  },
  {
    id: 4,
    image: blog4,
    title: "Comparing Nitrogen And Mechanical Freezers",
    like: "33",
    comment: "08",
    date: "13th March 2023",
    time: "5 min read",
  },
  {
    id: 5,
    image: blog5,
    title: "It Is Very Important To Wear Proper Clothing",
    like: "33",
    comment: "08",
    date: "5th May 2023",
    time: "5 min read",
  },
  {
    id: 6,
    image: blog6,
    title: "Hollowed-Out Faces More Cuts Amid Virus",
    like: "33",
    comment: "08",
    date: "19th June 2023",
    time: "5 min read",
  },
  {
    id: 7,
    image: blog7,
    title: "A Researcher Is Research On Coronavirus In Lab",
    like: "33",
    comment: "08",
    date: "20th June 2023",
    time: "5 min read",
  },
  {
    id: 8,
    image: blog8,
    title: "Using Spectroscopy To Assess Food Quality",
    like: "33",
    comment: "08",
    date: "31st Aug 2023",
    time: "5 min read",
  },
  {
    id: 9,
    image: blog9,
    title: "You Have To Wash Your Hands For 20 Seconds",
    like: "33",
    comment: "08",
    date: "1th Sep 2023",
    time: "5 min read",
  },
];
